import { render, staticRenderFns } from "./configCompetitorGroup.vue?vue&type=template&id=48da0cbc&scoped=true"
import script from "./configCompetitorGroup.vue?vue&type=script&lang=js"
export * from "./configCompetitorGroup.vue?vue&type=script&lang=js"
import style0 from "./configCompetitorGroup.vue?vue&type=style&index=0&id=48da0cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48da0cbc",
  null
  
)

export default component.exports